var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHimLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 79.2233,
    y1: 432.7767,
    x2: 432.7767,
    y2: 79.2233,
    gradientTransform: "matrix(0.0976563,0,0,0.0976563,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,46.27451%,0%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(53.333333%,100%,21.176471%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 125.4971,
    y1: 482.0393,
    x2: 386.5031,
    y2: 29.9635,
    gradientTransform: "matrix(0.0976563,0,0,0.0976563,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(90.588235%,30.980392%,63.137255%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(95.686275%,14.117647%,36.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(98.039216%,5.882353%,25.098039%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 25 3.230469 C 27.941406 3.230469 30.792969 3.808594 33.476562 4.941406 C 36.066406 6.035156 38.398438 7.605469 40.402344 9.609375 C 42.402344 11.613281 43.976562 13.933594 45.070312 16.535156 C 46.203125 19.21875 46.777344 22.070312 46.777344 25.011719 C 46.777344 27.949219 46.203125 30.800781 45.070312 33.488281 C 43.976562 36.074219 42.402344 38.410156 40.402344 40.410156 C 38.398438 42.414062 36.074219 43.984375 33.476562 45.078125 C 30.792969 46.210938 27.941406 46.789062 25 46.789062 C 22.0625 46.789062 19.210938 46.210938 16.523438 45.078125 C 13.9375 43.984375 11.601562 42.414062 9.601562 40.410156 C 7.597656 38.410156 6.027344 36.085938 4.933594 33.488281 C 3.808594 30.792969 3.230469 27.941406 3.230469 25 C 3.230469 22.058594 3.808594 19.207031 4.941406 16.523438 C 6.035156 13.933594 7.605469 11.601562 9.609375 9.597656 C 11.613281 7.597656 13.933594 6.023438 16.535156 4.929688 C 19.207031 3.808594 22.058594 3.230469 25 3.230469 M 25 0.585938 C 11.511719 0.585938 0.585938 11.511719 0.585938 25 C 0.585938 38.488281 11.511719 49.414062 25 49.414062 C 38.488281 49.414062 49.414062 38.488281 49.414062 25 C 49.414062 11.511719 38.488281 0.585938 25 0.585938 Z M 25 0.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 42.253906 8.253906 C 42.253906 8.527344 42.238281 8.789062 42.1875 9.0625 L 37.277344 36.914062 C 36.824219 39.464844 34.363281 41.191406 31.816406 40.730469 C 29.269531 40.285156 27.539062 37.824219 27.996094 35.273438 L 28.359375 33.242188 C 28.582031 31.964844 28.25 30.714844 27.558594 29.726562 C 26.863281 28.738281 25.800781 28.007812 24.519531 27.785156 C 21.972656 27.335938 19.511719 29.042969 19.050781 31.582031 C 19.050781 31.59375 19.050781 31.59375 19.050781 31.601562 L 17.117188 42.570312 C 16.667969 45.117188 14.207031 46.847656 11.660156 46.386719 C 9.109375 45.9375 7.382812 43.476562 7.839844 40.929688 L 12.722656 13.085938 C 13.175781 10.535156 15.636719 8.808594 18.183594 9.269531 C 20.460938 9.667969 22.082031 11.667969 22.082031 13.917969 C 22.082031 14.191406 22.0625 14.453125 22.011719 14.726562 L 21.652344 16.757812 C 21.203125 19.308594 22.941406 21.769531 25.488281 22.21875 C 28.039062 22.667969 30.519531 20.9375 30.96875 18.386719 L 32.902344 7.433594 C 33.351562 4.882812 35.8125 3.15625 38.359375 3.613281 C 40.636719 4.011719 42.253906 6.015625 42.253906 8.253906 Z M 42.253906 8.253906 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHimLogo);
export default __webpack_public_path__ + "static/media/himLogo.2d6a2f3971f29e2e2f9586cd52c5636f.svg";
export { ForwardRef as ReactComponent };